import React, { MouseEventHandler, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormTextField, FormSubmit } from './formwrapper';
import { $disable, $enable } from './util';
import { labels } from './labels';

const VerificationCode = ({ show, mode, onClose }) => {
    if (show) {
        document.body.style.paddingRight = "-1";
    } else {
        document.body.style.paddingRight = "0";
    }

    const expireTime = (window as any).CODE_EXPIRATION * 60;
    const [code, setCode] = useState("");
    const [codeError, setCodeError] = useState(false);
    const history = useHistory();
    const [countdown, setCountdown] = useState(expireTime);
    const [checkingCode, setCheckingCode] = useState(false);
    const [invalidCode, setInvalidCode] = useState("");
    const [generalFailure, setGeneralFailure] = useState(false);
    const [invalidPhone, setInvalidPhone] = useState(false);
    const [triesExceeded, setTriesExceeded] = useState(false);

    useEffect(() => {
        let timer = setInterval(() => {
            setCountdown(countdown => countdown - 1);
            if (countdown <= 0) {
                clearInterval(timer)
            }
        }, 1000);
        return () => { clearInterval(timer) }
    }, [])

    const sendCode = () => {
        $enable("verify");
        $enable("code");
        try {
            FormSubmit("SEND_VERIFICATION_CODE", `api/appointments/SendVerificationCode?mode=${mode}`, [], {},
                (response) => {
                },
                (r) => {
                    setInvalidPhone(true);
                    setCode("");
                    $disable("code");
                    $disable("verify");
                    console.log(JSON.stringify(r));
                },
                (r) => {
                    setCode("");
                    if (r.error === "GLOBAL_TRIES_EXCEEDED" || r.error === "TRIES_EXCEEDED") {
                        setTriesExceeded(true);
                    } else if (r.error === "FAILURE") {
                        setCodeError(true);
                    } else {
                        setGeneralFailure(true);
                    }
                    console.log(JSON.stringify(r));
                });
        } catch (ex) {
            setCode("");
            setGeneralFailure(true);
            console.log(JSON.stringify(ex));
        }
    }

    useEffect(() => {
        if (show) {
            setCode("");
            setCheckingCode(false);
            setGeneralFailure(false);
            setCountdown(expireTime);
            setInvalidPhone(false);
            setTriesExceeded(false);
            $enable("verify");
            document.getElementById('code').focus();
            sendCode();
        }
    }, [show])

    const formatTime = (s: number) => {
        let minutes = Math.floor(s / 60);
        let seconds = s - (minutes * 60);

        return minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
    }

    const verify = () => {
        setCheckingCode(true);
        setGeneralFailure(false);
        setInvalidCode("");
        setInvalidPhone(false);
        $disable("verify");
        try {
            FormSubmit("VALIDATE_CODE", `api/appointments/ValidateCode?mode=${mode}`, [], `"${code}"`,
                (response) => {
                    setCheckingCode(false);
                    //$enable("verify");
                    history.push(`/insuranceinfo${window.location.search}`);
                },
                (r) => {
                    setCheckingCode(false);
                    setCode("");
                    //$enable("verify");
                    setGeneralFailure(true);
                },
                (r) => {
                    setCheckingCode(false);
                    setCode("");
                    if (r.error === "FAILURE") {
                        setInvalidCode("INVALID_CODE");
                        $enable("verify");
                    } else if (r.error === "TRIES_EXCEEDED" || r.error === "GLOBAL_TRIES_EXCEEDED") {
                        setTriesExceeded(true);
                        $enable("verify");
                    } else {
                        setGeneralFailure(true);
                        $enable("verify");
                    }

                });
        } catch {
            setCheckingCode(false);
            setCode("");
            $enable("verify");
        }
        //onClose && onClose();
    }

    const resend = (e) => {
        e.preventDefault();
        sendCode();
        setCheckingCode(false);
        setInvalidCode("");
        setGeneralFailure(false);
        setInvalidPhone(false);
        setCountdown(expireTime);
        setTriesExceeded(false);
    }

    return (<>
        <div className="modal" tabIndex={-1} aria-labelledby="moreFiltersLabel" aria-hidden="true" style={{ display: show ? "block" : "none" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        {mode === "VERIFY_PHONE" ? "Cell Phone Verification" : mode === "VERIFY_EMAIL" ? "Email Verification" : "Cell Phone/Email Verification"}
                    </div>
                    <div className="modal-body text-center">
                        <div className="d-flex justify-content-center">
                            <FormTextField label="Enter Code" className="mb-3" id="code" mask="number" autoComplete="off" onChange={(e) => setCode(e.target.value)} maxLength={6} />
                        </div>
                        {invalidCode && <div className="errorColor mt-1 mb-3"><strong>Invalid Code. Please try again.</strong></div>}
                        <div className="ml-3 mr-3">
                            <p>{!invalidPhone && !triesExceeded && !generalFailure && <> A verification code has been sent to your {mode === "VERIFY_PHONE" ? "cell phone" : mode === "VERIFY_EMAIL" ? "email" : "cell phone & email"}.<br />
                                {countdown > 0 && <>The code will expire in <strong>{formatTime(countdown)}</strong></>}</>}
                                {(generalFailure || (!checkingCode && countdown <= 0 && !invalidPhone && !triesExceeded)) && <>
                                    <div className="mt-3 errorColor" style={{ background: "rgba(255, 255, 0, 0.3)", borderRadius: "5px" }}>It appears something went wrong.
                                        Please <a href="#" onClick={(e) => { e.preventDefault(); onClose(); }}><u>click here</u></a> to try another verification code method or <a href="#" onClick={resend}><u>resend code</u></a>.</div>
                                    <div className="mt-3" style={{ fontSize: "90%"}}>{labels.general.callcenter}</div></>
                                }
                                {!checkingCode && invalidPhone && <>
                                    <div className="mt-3 errorColor" style={{ background: "rgba(255, 255, 0, 0.3)", borderRadius: "5px" }}>We were unable to send a code to the cell phone provided.
                                        Please <a href="#" onClick={(e) => { e.preventDefault(); onClose(); }}><u>click here</u></a> to try another cell phone or verification code method.</div>
                                    <div className="mt-3" style={{ fontSize: "90%" }}>{labels.general.callcenter}</div></>
                                }
                                {!checkingCode && triesExceeded && <>
                                    <div className="mt-3 errorColor" style={{ background: "rgba(255, 255, 0, 0.3)", borderRadius: "5px" }}>We were unable to verify
                                        your {mode === "VERIFY_PHONE" ? "cell phone" : mode === "VERIFY_EMAIL" ? "email" : "cell phone or email"}.
                                        Please <a href="#" onClick={(e) => { e.preventDefault(); onClose(); }}><u>click here</u></a> to try another {mode === "VERIFY_PHONE" ? "cell phone" : mode === "VERIFY_EMAIL" ? "email" : "cell phone/email"} or verification code method.</div>
                                    <div className="mt-3" style={{ fontSize: "90%" }}>{labels.general.callcenter}</div>
                                </>}
                            </p>
                        </div>
                    </div>
                    <div className="pt-4 pl-4 pr-4 border-top">
                        <div className="row flex-row-reverse">
                            <div className="col-md mb-4">
                                <button type="button" className="btn btn-primary pl-5 pr-5 btn-block" id="verify" data-dismiss="modal" onClick={verify}>Verify</button>
                            </div>
                            <div className="col-md mb-4">
                                <a href="#" className="btn btn-outline-primary btn-block" onClick={(e) => { e.preventDefault(); onClose(); }}>&larr; Try Another Verification Method</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {show && <div className={"modal-backdrop fade show"}></div>}
    </>
    );
}

export default VerificationCode;